import React from 'react';
import * as S from './GoSafeInfoLoader.styles';

const GoSafeInfoLoader = () => (
  <S.GoSafeInfoLoaderWrapDiv>
    <S.GoSafeInfoImgLoader></S.GoSafeInfoImgLoader>
    <S.GoSafeInfoContextWrap>
      <S.GoSafeInfoSmallTextLoader></S.GoSafeInfoSmallTextLoader>
      <S.GoSafeInfoLargeTextLoader></S.GoSafeInfoLargeTextLoader>
    </S.GoSafeInfoContextWrap>
  </S.GoSafeInfoLoaderWrapDiv>
);

export default GoSafeInfoLoader;
